export const BUS_BOOKING_FORM_CHANGE_CONTACT_PHONE =
  'BUS/CHANGE_CONTACT_PHONE_BOOKING_FORM';

export default contactPhone => dispatch => {
  return dispatch({
    type: BUS_BOOKING_FORM_CHANGE_CONTACT_PHONE,
    contactPhone,
  });
};
